import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "../../../hooks/useAppContext";

interface IPinStyle {
	id: string;
	url: string;
	width: number;
	height: number;
	centerX?: number; // default = width/2
	centerY?: number; // default = height/2
	// dropShadow?: IPinDropShadow; // TODO
}

/**
 * Get all styles with a thumb url
 */
export const usePinStyles = () => {
	const { reactQueryNoReloadOptions } = useAppContext();

	const getPinStylesAsync = () => {
		// URL invalidation at new version
		//const url = `${context.osmTileServerUrl}/${client.stampRelativeUrl("pin-styles/styles.json")}`;
		//const styles = await ajax.getJSON<IPinStyle[]>(url);

		return Promise.resolve([
			{
				id: "pin-red",
				url: `https://upload.wikimedia.org/wikipedia/commons/d/d1/Google_Maps_pin.svg`,
				width: 21,
				height: 37,
				centerX: 10.5,
				centerY: 37,
			},
			{
				id: "pin-3d-red",
				url: `https://png.pngtree.com/png-clipart/20230325/original/pngtree-paper-red-pin-transparent-vector-png-image_9004271.png`,
				width: 1200,
				height: 1200,
				centerX: 435,
				centerY: 1177,
			},
			{
				id: "pin-haert-red",
				url: `https://cdn-icons-png.freepik.com/512/833/833472.png`,
				width: 512,
				height: 512,
				centerX: 256,
				centerY: 467,
			},
			{
				id: "pin-heart-black",
				url: `https://cdn-icons-png.freepik.com/512/833/833386.png`,
				width: 512,
				height: 512,
				centerX: 256,
				centerY: 467,
			},
			{
				id: "pin-flag-black",
				url: `https://cdn0.iconfinder.com/data/icons/map-location-solid-style/91/Map_-_Location_Solid_Style_05-1024.png`,
				width: 1024,
				height: 1024,
				centerX: 370,
				centerY: 819,
			},
		] satisfies IPinStyle[]);
	};

	return useQuery(["use-pin-styles"], getPinStylesAsync, {
		...reactQueryNoReloadOptions,
		retry: 4,
		meta: {
			logToServer: true,
			errorPrefix: "Error loading pin styles",
		},
	});
};
